import { render } from "./ProfileSocial.vue?vue&type=template&id=0b9a8574&scoped=true"
import script from "./ProfileSocial.vue?vue&type=script&lang=js"
export * from "./ProfileSocial.vue?vue&type=script&lang=js"

import "./ProfileSocial.vue?vue&type=style&index=0&id=0b9a8574&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9a8574"]])

export default __exports__